import { eyeIcon } from "../config/icons";

const EyeIcon = ({ onClick, hidden }) => {
  if (hidden) return "";
  return (
    <button className="btn-status btn-edit" type="button" onClick={onClick}>
      <img src={eyeIcon} width={30} height={30} alt="edit" />
    </button>
  );
};

export default EyeIcon;
